import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import $ from 'jquery'
export default function Sidebar_component({ sidebarOpen }) {
  const [companylogo, setCompanylogo] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [permissions, setPermissions] = useState([]);

  useEffect(() => {
    let comlogo = localStorage.getItem('companylogo');
    let comName = localStorage.getItem('mem_company_name');
    setCompanylogo(comlogo);
    setCompanyName(comName);
    const storedPermissions = JSON.parse(localStorage.getItem('user_permissions')) || [];
    setPermissions(storedPermissions);
  })
  return (
    <div>
      <div className={`vl_dsh_sidebar ${sidebarOpen ? "open" : ""}`}>
        <div className='sidebar_menu'>
          <div className='side_bar_logo'>
            <img src={companylogo} alt="Company logo" />
          </div>
          <h3 className='comname_text'>{companyName}</h3>
          <ul>
            <li className='menu_heading'>Manage</li>
            <li className='redicon'><Link to="/create">< i className='ri-add-circle-fill'></i>Create</Link></li>

            {(permissions.includes("project.manage") || permissions.includes("budget.view")) && (
              <li ><Link to="/projectlist">< i className='ri-apps-2-line'></i>Projects</Link></li>
            )}
            {permissions.includes("view.own.project") && (
              <li className='memberprojects'>
                <Link to="/member_projectlist">
                  <i className='ri-apps-2-line'></i>Projects
                </Link>
              </li>
            )}

            <li className='memberdailyreport'><Link to="/member_daily_report">< i className='ri-ticket-line'></i>Daily Report</Link></li>

            {permissions.includes("user.manage") && (
              <li className='adminadddmember'><Link to="/add_member">< i className='ri-ticket-line'></i>Add Member</Link></li>
            )}

            <li className='menu_heading'>Personal</li>

            <li className='adminhome'><Link to="/dashboard">< i className='ri-home-2-line'></i>Home</Link></li>

            {permissions.includes("tasks.view_all") && (
              <li className='adminmenu' ><Link to="/admin_mytask">< i className='ri-task-line'></i>My tasks</Link></li>
            )}

            {permissions.includes("task.view_own") && (
              <li className='membertask' ><Link to="/my_task">< i className='ri-task-line'></i>My tasks</Link></li>
            )}


            <li ><Link to="/inbox">< i className='ri-mail-line'></i>Inbox</Link></li>

            <li className='menu_heading'>Advance Options</li>

            {permissions.includes("project.manage") && (
              <li><Link to="/project_insight"><i className='ri-eye-line'></i>Project insight</Link></li>
            )}

            <li><Link to="/meeting_room"><i className='ri-chat-voice-line'></i>Meeting Room</Link></li>

            <li className='nodisplay' ><Link to="">< i className='ri-flashlight-line'></i>AI center</Link></li>

            <li className='menu_heading'>Time Tracking</li>

            {permissions.includes("timesheet.view_all") && (
              <li><Link to="/timesheet">< i className='ri-time-line'></i>Time sheets</Link></li>
            )}

            {permissions.includes("timesheet.view_own") && (
              <li><Link to="/my_timesheet">< i className='ri-time-line'></i>My Time sheet</Link></li>
            )}

            {permissions.includes("worklog.manage") && (
              <li><Link to="/worklog">< i className='ri-table-view'></i>Work Logs</Link></li>
            )}

            {permissions.includes("worklog.view_own") && (
              <li><Link to="/my_worklog">< i className='ri-table-view'></i>My Work Logs</Link></li>
            )}

            {permissions.includes("billable_hours.calculate") && (
              <li className='adminmenu'><Link to="/bilable_hours">< i className='ri-money-dollar-box-line'></i>Billable Hours</Link></li>
            )}

            <li className='nodisplay' ><Link to="">< i className='ri-settings-4-line'></i>Tracker Settings</Link></li>

            <li className='menu_heading adminmenu'>Admin Settings</li>

            {permissions.includes("user.manage") && (
              <li className='adminmenu'><Link to="/user_management">< i className='ri-shield-user-line'></i>User Management</Link></li>
            )}

            {permissions.includes("role.manage") && (
              <li><Link to="/role_permission">< i className='ri-key-2-line'></i>Roles and permissions</Link></li>
            )}

            <li className='menu_heading'>Organization</li>



            <li><Link to="/companymember_list">< i className='ri-team-fill'></i>Teams</Link></li>

            <li ><Link to="/goals">< i className='ri-eye-fill'></i>Goals</Link></li>

            {/* 
{permissions.includes("leaders_report.view") && (
  <li className='adminmenu'>
    <Link to="">
      <i className='ri-speaker-2-line'></i>
      Leader's report
    </Link>
  </li>
)} 
*/}
            {permissions.includes("account.cancel") && (
              <li className='adminmenu'><Link to="/cancel_account">< i className='ri-close-fill'></i>Cancle Account</Link></li>
            )}

          </ul>
        </div>
      </div>
    </div>
  )
}
